import { useState } from "react";
import { t } from "i18next";
import ApiUrls from "../../../../helpers/urls/ApiUrls";
import RouteUrls from "../../../../helpers/urls/RouteUrls";
import { appendFormData } from "../../../../helpers/functions/form-append";
import { anycastError } from "../../functions/anycastError";
import AddLayout from "../../../../components/AddLayout";
import AddSiteForm from "../../components/addForm";

function AddSite() {
  const [formData, setFormData] = useState({
    name: "",
    mgmtip: "",
    anycast: [""],
    cachesizenum: "",
    cachesizeunit: "M",
    inactivenum: "",
    inactiveunit: "s"
  });
  const {
    name,
    mgmtip,
    anycast,
    cachesizenum,
    cachesizeunit,
    inactivenum,
    inactiveunit
  } = formData;
  const [errors, setErrors] = useState({});
  const [postFormData, setPostFormData] = useState(null);

  const checkInputs = () => {
    let temp_errors = {};

    if (name === "") {
      temp_errors.name = t("message.required", { item: t("site.site_name") });
    }
    if (mgmtip === "") {
      temp_errors.mgmtip = t("message.required", { item: t("site.management_ip") });
    }

    const anycast_error = anycastError(anycast);
    if (anycast_error.error) {
      temp_errors.anycast = anycast_error.error;
    }

    if (cachesizenum === "") {
      temp_errors.cachesizenum = t("message.required", { item: t("site.cache_size") });
    }
    if (cachesizeunit === "") {
      temp_errors.cachesizeunit = t("message.required", { item: t("global.unit") });
    }
    if (inactivenum === "") {
      temp_errors.inactivenum = t("message.required", { item: t("site.cache_inactive") });
    }
    if (inactiveunit === "") {
      temp_errors.inactiveunit = t("message.required", { item: t("global.unit") });
    }

    setErrors(temp_errors);
    setFormData({
      ...formData,
      anycast: anycast_error.filteredAnycast,
    });

    if (Object.keys(temp_errors).length === 0) {
      createPostFormData();
    }
  }

  const createPostFormData = () => {
    setPostFormData(appendFormData(formData));
  }

  return (
    <AddLayout
      title={t("site.site")}
      addUrl={ApiUrls.site.add}
      listUrl={RouteUrls.site.list}
      onClick={checkInputs}
      postFormData={postFormData}
    >
      <AddSiteForm
        formData={formData}
        setFormData={setFormData}
        errors={errors}
        setErrors={setErrors}
      />
    </AddLayout>
  );
}

export default AddSite;
